import { render, staticRenderFns } from "./MaterialCategoryEdit.vue?vue&type=template&id=6dddf41a&"
import script from "./MaterialCategoryEdit.js?vue&type=script&lang=js&"
export * from "./MaterialCategoryEdit.js?vue&type=script&lang=js&"
import style0 from "./MaterialCategoryEdit.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports